import { ComponentProps, ElementType } from 'react';

import { useSegmentEventWrapper } from '@/hooks/useSegmentEventWrapper';

type ButtonWithTrackingProps<T extends ElementType> = {
  as?: T;
  eventName: string;
} & ComponentProps<T>;

export function ButtonWithTracking<T extends ElementType = 'button'>({
  as,
  eventName,
  onClick,
  ...rest
}: ButtonWithTrackingProps<T>) {
  const track = useSegmentEventWrapper(eventName);
  const trackedOnClick = onClick ? track(onClick) : undefined;

  const Component = as || 'button';

  return <Component onClick={trackedOnClick} {...rest} />;
}
